// Auto-generated by scripts/parse-features.ts
// Do not edit manually
import type { ParsedFeature } from '../types/gherkin';

export const parsedFeatures: ParsedFeature[] = [
  {
    "id": "us-9",
    "name": "US-9 Visualiser la photo d'un individu",
    "description": "En tant qu'utilisateur Je peux visualiser la photo d'un individu ou ajouter une photo personnelle sur une fiche existante Et consulter la liste des inscrits à un atelier Afin d'identifier les personnes que j'ai rencontrées dont je n'ai pas noté leur nom",
    "tags": [
      "@USER",
      "@priority-0"
    ],
    "category": "USER",
    "priority": 0,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Accéder au profil pour voir la photo",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"mon profil\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran contient un avatar"
          }
        ]
      },
      {
        "name": "Naviguer vers le profil depuis la liste des participants",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"détail événement\""
          },
          {
            "keyword": "Quand",
            "text": "je clique sur un participant"
          },
          {
            "keyword": "Alors",
            "text": "je suis redirigé vers \"profil utilisateur\""
          },
          {
            "keyword": "Et",
            "text": "l'écran affiche les informations du profil"
          }
        ]
      },
      {
        "name": "Consulter la liste des inscrits à un atelier",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"détail événement\""
          },
          {
            "keyword": "Alors",
            "text": "je peux voir la liste des participants"
          }
        ]
      },
      {
        "name": "Vérifier les champs de données du profil",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"mon profil\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran contient un texte \"Marie Dupont\""
          },
          {
            "keyword": "Et",
            "text": "l'écran contient un texte \"@mariedupont\""
          }
        ]
      },
      {
        "name": "Ajouter une photo personnelle sur une fiche existante",
        "tags": [],
        "steps": []
      }
    ],
    "filePath": "features/user/us-9-visualiser-photo.feature",
    "rawContent": "# language: fr\n@USER @priority-0\nFonctionnalité: US-9 Visualiser la photo d'un individu\n  En tant qu'utilisateur\n  Je peux visualiser la photo d'un individu ou ajouter une photo personnelle sur une fiche existante\n  Et consulter la liste des inscrits à un atelier\n  Afin d'identifier les personnes que j'ai rencontrées dont je n'ai pas noté leur nom\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Accéder au profil pour voir la photo\n    Étant donné que je suis sur la page \"mon profil\"\n    Alors l'écran contient un avatar\n\n  Scénario: Naviguer vers le profil depuis la liste des participants\n    Étant donné que je suis sur la page \"détail événement\"\n    Quand je clique sur un participant\n    Alors je suis redirigé vers \"profil utilisateur\"\n    Et l'écran affiche les informations du profil\n\n  Scénario: Consulter la liste des inscrits à un atelier\n    Étant donné que je suis sur la page \"détail événement\"\n    Alors je peux voir la liste des participants\n\n  Scénario: Vérifier les champs de données du profil\n    Étant donné que je suis sur la page \"mon profil\"\n    Alors l'écran contient un texte \"Marie Dupont\"\n    Et l'écran contient un texte \"@mariedupont\"\n\n  Scénario: Ajouter une photo personnelle sur une fiche existante\n    * Scénario non implémenté\n",
    "screenIds": [
      "event-detail",
      "profile",
      "user-profile"
    ]
  },
  {
    "id": "us-13",
    "name": "US-13 Relayer/Modifier/Supprimer un événement",
    "description": "En tant qu'utilisateur Je peux relayer/modifier/supprimer un événement En choisissant les dates, horaires, lieu et thématique Afin de relayer/présenter le contenu de cet événement et le catégoriser",
    "tags": [
      "@EVENT",
      "@priority-1"
    ],
    "category": "EVENT",
    "priority": 1,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Accéder au formulaire de relai d'événement",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"accueil\""
          },
          {
            "keyword": "Quand",
            "text": "je navigue vers \"relayer un événement\""
          },
          {
            "keyword": "Alors",
            "text": "je vois l'écran \"create-event\""
          }
        ]
      },
      {
        "name": "Vérifier les champs obligatoires du formulaire",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "l'écran \"create-event\" est affiché"
          },
          {
            "keyword": "Alors",
            "text": "le formulaire contient les champs obligatoires suivants:"
          }
        ]
      },
      {
        "name": "Vérifier la présence du bouton de relai",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"relayer un événement\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran contient une section \"Relayer l'événement\""
          }
        ]
      },
      {
        "name": "Pouvoir annuler le relai d'événement",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"relayer un événement\""
          },
          {
            "keyword": "Alors",
            "text": "je peux annuler et revenir à l'écran précédent"
          }
        ]
      },
      {
        "name": "Détecter un événement similaire déjà relayé",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "l'écran \"create-event\" est affiché"
          },
          {
            "keyword": "Alors",
            "text": "le formulaire permet de détecter les doublons"
          }
        ]
      },
      {
        "name": "Importer un événement depuis une source externe",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "l'écran \"create-event\" est affiché"
          },
          {
            "keyword": "Alors",
            "text": "le formulaire permet d'importer depuis Mobilizon ou Transiscope"
          }
        ]
      },
      {
        "name": "Pas d'alerte doublon lors d'un import externe",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "l'écran \"create-event\" est affiché"
          },
          {
            "keyword": "Alors",
            "text": "l'import externe ne déclenche pas d'alerte doublon"
          }
        ]
      },
      {
        "name": "Modifier un événement",
        "tags": [],
        "steps": []
      },
      {
        "name": "Supprimer un événement",
        "tags": [],
        "steps": []
      },
      {
        "name": "Retirer une organisation (personne ou structure)",
        "tags": [],
        "steps": []
      }
    ],
    "filePath": "features/event/us-13-creer-evenement.feature",
    "rawContent": "# language: fr\n@EVENT @priority-1\nFonctionnalité: US-13 Relayer/Modifier/Supprimer un événement\n  En tant qu'utilisateur\n  Je peux relayer/modifier/supprimer un événement\n  En choisissant les dates, horaires, lieu et thématique\n  Afin de relayer/présenter le contenu de cet événement et le catégoriser\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Accéder au formulaire de relai d'événement\n    Étant donné que je suis sur la page \"accueil\"\n    Quand je navigue vers \"relayer un événement\"\n    Alors je vois l'écran \"create-event\"\n\n  Scénario: Vérifier les champs obligatoires du formulaire\n    Étant donné que l'écran \"create-event\" est affiché\n    Alors le formulaire contient les champs obligatoires suivants:\n      | Nom de l'événement |\n      | Date de début      |\n      | Heure de début     |\n      | Lieu               |\n      | Thématique         |\n\n  Scénario: Vérifier la présence du bouton de relai\n    Étant donné que je suis sur la page \"relayer un événement\"\n    Alors l'écran contient une section \"Relayer l'événement\"\n\n  Scénario: Pouvoir annuler le relai d'événement\n    Étant donné que je suis sur la page \"relayer un événement\"\n    Alors je peux annuler et revenir à l'écran précédent\n\n  Scénario: Détecter un événement similaire déjà relayé\n    Étant donné que l'écran \"create-event\" est affiché\n    Alors le formulaire permet de détecter les doublons\n\n  Scénario: Importer un événement depuis une source externe\n    Étant donné que l'écran \"create-event\" est affiché\n    Alors le formulaire permet d'importer depuis Mobilizon ou Transiscope\n\n  Scénario: Pas d'alerte doublon lors d'un import externe\n    Étant donné que l'écran \"create-event\" est affiché\n    Alors l'import externe ne déclenche pas d'alerte doublon\n\n  Scénario: Modifier un événement\n    * Scénario non implémenté\n\n  Scénario: Supprimer un événement\n    * Scénario non implémenté\n\n  Scénario: Retirer une organisation (personne ou structure)\n    * Scénario non implémenté\n",
    "screenIds": [
      "create-event",
      "home"
    ]
  },
  {
    "id": "us-3",
    "name": "US-3 Visualiser un événement terminé",
    "description": "En tant qu'utilisateur Je peux visualiser un événement terminé et consulter la description de l'événement Afin de voir les personnes qui ont participé à cet événement",
    "tags": [
      "@EVENT",
      "@priority-1"
    ],
    "category": "EVENT",
    "priority": 1,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Accéder aux détails d'un événement terminé",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"accueil\""
          },
          {
            "keyword": "Quand",
            "text": "je clique sur un événement"
          },
          {
            "keyword": "Alors",
            "text": "je vois l'écran \"event-detail\""
          }
        ]
      },
      {
        "name": "Voir la description de l'événement",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"détail événement\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran affiche les informations de l'événement"
          }
        ]
      },
      {
        "name": "Voir la liste des participants",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"détail événement\""
          },
          {
            "keyword": "Alors",
            "text": "je peux voir la liste des participants"
          }
        ]
      }
    ],
    "filePath": "features/event/us-3-visualiser-evenement-termine.feature",
    "rawContent": "# language: fr\n@EVENT @priority-1\nFonctionnalité: US-3 Visualiser un événement terminé\n  En tant qu'utilisateur\n  Je peux visualiser un événement terminé et consulter la description de l'événement\n  Afin de voir les personnes qui ont participé à cet événement\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Accéder aux détails d'un événement terminé\n    Étant donné que je suis sur la page \"accueil\"\n    Quand je clique sur un événement\n    Alors je vois l'écran \"event-detail\"\n\n  Scénario: Voir la description de l'événement\n    Étant donné que je suis sur la page \"détail événement\"\n    Alors l'écran affiche les informations de l'événement\n\n  Scénario: Voir la liste des participants\n    Étant donné que je suis sur la page \"détail événement\"\n    Alors je peux voir la liste des participants\n",
    "screenIds": [
      "event-detail",
      "home"
    ]
  },
  {
    "id": "us-7",
    "name": "US-7 M'inscrire/me désinscrire à un événement",
    "description": "En tant qu'utilisateur Je peux m'inscrire/me désinscrire à un événement Après avoir consulté la description de l'événement, les dates et le lieu S'il existe déjà dans le système ou en le retrouvant dans une base existante",
    "tags": [
      "@EVENT",
      "@priority-1"
    ],
    "category": "EVENT",
    "priority": 1,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Consulter un événement avant inscription",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"détail événement\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran affiche les informations de l'événement"
          }
        ]
      },
      {
        "name": "S'inscrire à un événement",
        "tags": [],
        "steps": []
      },
      {
        "name": "Se désinscrire d'un événement",
        "tags": [],
        "steps": []
      },
      {
        "name": "Rechercher un événement existant",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"découvrir\""
          },
          {
            "keyword": "Alors",
            "text": "je peux voir la liste des événements"
          }
        ]
      },
      {
        "name": "Vérifier les données de l'écran",
        "tags": [],
        "steps": []
      },
      {
        "name": "Rechercher dans une base existante (Mobilizon)",
        "tags": [],
        "steps": []
      }
    ],
    "filePath": "features/event/us-7-inscription-evenement.feature",
    "rawContent": "# language: fr\n@EVENT @priority-1\nFonctionnalité: US-7 M'inscrire/me désinscrire à un événement\n  En tant qu'utilisateur\n  Je peux m'inscrire/me désinscrire à un événement\n  Après avoir consulté la description de l'événement, les dates et le lieu\n  S'il existe déjà dans le système ou en le retrouvant dans une base existante\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Consulter un événement avant inscription\n    Étant donné que je suis sur la page \"détail événement\"\n    Alors l'écran affiche les informations de l'événement\n\n  Scénario: S'inscrire à un événement\n    * Scénario non implémenté\n\n  Scénario: Se désinscrire d'un événement\n    * Scénario non implémenté\n\n  Scénario: Rechercher un événement existant\n    Étant donné que je suis sur la page \"découvrir\"\n    Alors je peux voir la liste des événements\n\n  Scénario: Vérifier les données de l'écran\n    * Scénario non implémenté\n\n  Scénario: Rechercher dans une base existante (Mobilizon)\n    * Scénario non implémenté\n",
    "screenIds": [
      "event-detail",
      "events"
    ]
  },
  {
    "id": "us-16",
    "name": "US-16 Indiquer un ou plusieurs points de rencontre",
    "description": "En tant qu'utilisateur Je peux indiquer un ou plusieurs points de rencontre En précisant le lieu et l'heure de cette rencontre Afin de croiser et faire connaissance d'autres participants",
    "tags": [
      "@MEETING",
      "@priority-1"
    ],
    "category": "MEETING",
    "priority": 1,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Accéder aux points de rencontre",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"détail événement\""
          },
          {
            "keyword": "Quand",
            "text": "je navigue vers \"points de rencontre\""
          },
          {
            "keyword": "Alors",
            "text": "je vois l'écran \"meeting-points\""
          }
        ]
      },
      {
        "name": "Voir le bouton pour proposer un point de rencontre",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"points de rencontre\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran contient un bouton \"Proposer un point de rencontre\""
          }
        ]
      },
      {
        "name": "Ouvrir le formulaire de proposition",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"points de rencontre\""
          },
          {
            "keyword": "Quand",
            "text": "je clique sur \"Proposer un point de rencontre\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran contient un bouton \"Créer le point de rencontre\""
          },
          {
            "keyword": "Et",
            "text": "l'écran contient un champ \"Lieu\""
          }
        ]
      },
      {
        "name": "Définir l'heure de rencontre",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"points de rencontre\""
          },
          {
            "keyword": "Quand",
            "text": "je clique sur \"Proposer un point de rencontre\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran contient un bouton \"30 min avant\""
          },
          {
            "keyword": "Et",
            "text": "l'écran contient un bouton \"1h avant\""
          },
          {
            "keyword": "Et",
            "text": "l'écran contient un bouton \"Personnalisé\""
          }
        ]
      }
    ],
    "filePath": "features/meeting/us-16-point-rencontre.feature",
    "rawContent": "# language: fr\n@MEETING @priority-1\nFonctionnalité: US-16 Indiquer un ou plusieurs points de rencontre\n  En tant qu'utilisateur\n  Je peux indiquer un ou plusieurs points de rencontre\n  En précisant le lieu et l'heure de cette rencontre\n  Afin de croiser et faire connaissance d'autres participants\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Accéder aux points de rencontre\n    Étant donné que je suis sur la page \"détail événement\"\n    Quand je navigue vers \"points de rencontre\"\n    Alors je vois l'écran \"meeting-points\"\n\n  Scénario: Voir le bouton pour proposer un point de rencontre\n    Étant donné que je suis sur la page \"points de rencontre\"\n    Alors l'écran contient un bouton \"Proposer un point de rencontre\"\n\n  Scénario: Ouvrir le formulaire de proposition\n    Étant donné que je suis sur la page \"points de rencontre\"\n    Quand je clique sur \"Proposer un point de rencontre\"\n    Alors l'écran contient un bouton \"Créer le point de rencontre\"\n    Et l'écran contient un champ \"Lieu\"\n\n  Scénario: Définir l'heure de rencontre\n    Étant donné que je suis sur la page \"points de rencontre\"\n    Quand je clique sur \"Proposer un point de rencontre\"\n    Alors l'écran contient un bouton \"30 min avant\"\n    Et l'écran contient un bouton \"1h avant\"\n    Et l'écran contient un bouton \"Personnalisé\"\n",
    "screenIds": [
      "event-detail",
      "meeting-points"
    ]
  },
  {
    "id": "us-10",
    "name": "US-10 Visualiser la fiche/le profil d'un participant",
    "description": "En tant qu'utilisateur Je peux sélectionner un individu dans la liste des inscrits à un événement/atelier Afin de voir les événements auxquels la personne a participé et voir un formulaire de contact",
    "tags": [
      "@USER",
      "@priority-1"
    ],
    "category": "USER",
    "priority": 1,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Accéder au profil d'un participant",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"détail événement\""
          },
          {
            "keyword": "Quand",
            "text": "je clique sur un participant"
          },
          {
            "keyword": "Alors",
            "text": "je vois l'écran \"user-profile\""
          }
        ]
      },
      {
        "name": "Voir les événements du participant",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"profil utilisateur\""
          },
          {
            "keyword": "Alors",
            "text": "je peux voir les événements auxquels l'utilisateur a participé"
          }
        ]
      },
      {
        "name": "Voir la localisation des événements",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"profil utilisateur\""
          },
          {
            "keyword": "Alors",
            "text": "les événements affichent leur localisation et distance"
          }
        ]
      },
      {
        "name": "Voir le formulaire de contact",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"profil utilisateur\""
          },
          {
            "keyword": "Alors",
            "text": "je peux contacter l'utilisateur"
          }
        ]
      },
      {
        "name": "Vérifier les informations du profil",
        "tags": [],
        "steps": []
      },
      {
        "name": "Voir les détails du profil utilisateur",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"profil utilisateur\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran affiche les informations du profil"
          }
        ]
      }
    ],
    "filePath": "features/user/us-10-profil-participant.feature",
    "rawContent": "# language: fr\n@USER @priority-1\nFonctionnalité: US-10 Visualiser la fiche/le profil d'un participant\n  En tant qu'utilisateur\n  Je peux sélectionner un individu dans la liste des inscrits à un événement/atelier\n  Afin de voir les événements auxquels la personne a participé et voir un formulaire de contact\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Accéder au profil d'un participant\n    Étant donné que je suis sur la page \"détail événement\"\n    Quand je clique sur un participant\n    Alors je vois l'écran \"user-profile\"\n\n  Scénario: Voir les événements du participant\n    Étant donné que je suis sur la page \"profil utilisateur\"\n    Alors je peux voir les événements auxquels l'utilisateur a participé\n\n  Scénario: Voir la localisation des événements\n    Étant donné que je suis sur la page \"profil utilisateur\"\n    Alors les événements affichent leur localisation et distance\n\n  Scénario: Voir le formulaire de contact\n    Étant donné que je suis sur la page \"profil utilisateur\"\n    Alors je peux contacter l'utilisateur\n\n  Scénario: Vérifier les informations du profil\n    * Scénario non implémenté\n\n  Scénario: Voir les détails du profil utilisateur\n    Étant donné que je suis sur la page \"profil utilisateur\"\n    Alors l'écran affiche les informations du profil\n",
    "screenIds": [
      "event-detail",
      "user-profile"
    ]
  },
  {
    "id": "us-15",
    "name": "US-15 Visualiser les inscrits à un atelier/événement",
    "description": "En tant qu'utilisateur Je peux visualiser les inscrits à un atelier/événement En sélectionnant l'atelier/l'événement désiré dans la liste Afin de consulter la liste des inscrits triée par ordre alphabétique",
    "tags": [
      "@USER",
      "@priority-1"
    ],
    "category": "USER",
    "priority": 1,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Accéder à la liste des inscrits d'un événement",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"détail événement\""
          },
          {
            "keyword": "Alors",
            "text": "je peux voir la liste des participants"
          }
        ]
      },
      {
        "name": "Accéder à la liste des inscrits d'un atelier",
        "tags": [],
        "steps": []
      },
      {
        "name": "Voir la liste des participants d'un événement",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"détail événement\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran contient une section \"Participants\""
          }
        ]
      },
      {
        "name": "Voir la liste des participants d'un atelier",
        "tags": [],
        "steps": []
      },
      {
        "name": "Cliquer sur un inscrit pour voir son profil",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"détail événement\""
          },
          {
            "keyword": "Quand",
            "text": "je clique sur un participant"
          },
          {
            "keyword": "Alors",
            "text": "je vois l'écran \"user-profile\""
          }
        ]
      }
    ],
    "filePath": "features/user/us-15-visualiser-inscrits.feature",
    "rawContent": "# language: fr\n@USER @priority-1\nFonctionnalité: US-15 Visualiser les inscrits à un atelier/événement\n  En tant qu'utilisateur\n  Je peux visualiser les inscrits à un atelier/événement\n  En sélectionnant l'atelier/l'événement désiré dans la liste\n  Afin de consulter la liste des inscrits triée par ordre alphabétique\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Accéder à la liste des inscrits d'un événement\n    Étant donné que je suis sur la page \"détail événement\"\n    Alors je peux voir la liste des participants\n\n  Scénario: Accéder à la liste des inscrits d'un atelier\n    * Scénario non implémenté\n\n  Scénario: Voir la liste des participants d'un événement\n    Étant donné que je suis sur la page \"détail événement\"\n    Alors l'écran contient une section \"Participants\"\n\n  Scénario: Voir la liste des participants d'un atelier\n    * Scénario non implémenté\n\n  Scénario: Cliquer sur un inscrit pour voir son profil\n    Étant donné que je suis sur la page \"détail événement\"\n    Quand je clique sur un participant\n    Alors je vois l'écran \"user-profile\"\n",
    "screenIds": [
      "event-detail",
      "user-profile"
    ]
  },
  {
    "id": "us-23",
    "name": "US-23 Me connecter avec d'autres utilisateurs",
    "description": "En tant qu'utilisateur Je peux me connecter avec d'autres utilisateurs En partageant mon QR code ou mon lien de contact Afin d'étendre mon réseau",
    "tags": [
      "@USER",
      "@priority-1"
    ],
    "category": "USER",
    "priority": 1,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Accéder au partage depuis le profil",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"mon profil\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran contient une section \"Partager\""
          }
        ]
      },
      {
        "name": "Voir le QR code",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"partage profil\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran contient un texte \"Scannez pour me retrouver sur Festipod\""
          }
        ]
      },
      {
        "name": "Voir le lien de partage",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"partage profil\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran contient une section \"Mon lien de profil\""
          }
        ]
      },
      {
        "name": "Accéder à l'écran de partage dédié",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"mon profil\""
          },
          {
            "keyword": "Quand",
            "text": "je navigue vers \"partage de profil\""
          },
          {
            "keyword": "Alors",
            "text": "je vois l'écran \"share-profile\""
          }
        ]
      },
      {
        "name": "Vérifier les données du profil",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"partage profil\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran contient un texte \"Marie Dupont\""
          }
        ]
      }
    ],
    "filePath": "features/user/us-23-connexion-utilisateurs.feature",
    "rawContent": "# language: fr\n@USER @priority-1\nFonctionnalité: US-23 Me connecter avec d'autres utilisateurs\n  En tant qu'utilisateur\n  Je peux me connecter avec d'autres utilisateurs\n  En partageant mon QR code ou mon lien de contact\n  Afin d'étendre mon réseau\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Accéder au partage depuis le profil\n    Étant donné que je suis sur la page \"mon profil\"\n    Alors l'écran contient une section \"Partager\"\n\n  Scénario: Voir le QR code\n    Étant donné que je suis sur la page \"partage profil\"\n    Alors l'écran contient un texte \"Scannez pour me retrouver sur Festipod\"\n\n  Scénario: Voir le lien de partage\n    Étant donné que je suis sur la page \"partage profil\"\n    Alors l'écran contient une section \"Mon lien de profil\"\n\n  Scénario: Accéder à l'écran de partage dédié\n    Étant donné que je suis sur la page \"mon profil\"\n    Quand je navigue vers \"partage de profil\"\n    Alors je vois l'écran \"share-profile\"\n\n  Scénario: Vérifier les données du profil\n    Étant donné que je suis sur la page \"partage profil\"\n    Alors l'écran contient un texte \"Marie Dupont\"\n",
    "screenIds": [
      "profile",
      "share-profile"
    ]
  },
  {
    "id": "us-20",
    "name": "US-20 Voir le profil des personnes faisant partie de mon réseau",
    "description": "En tant qu'utilisateur Je peux voir le profil des personnes faisant partie de mon réseau Ainsi que le profil des personnes publiques Et consulter la description de l'événement afin de savoir si je veux participer",
    "tags": [
      "@USER",
      "@priority-1"
    ],
    "category": "USER",
    "priority": 1,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Accéder à mon profil",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"accueil\""
          },
          {
            "keyword": "Quand",
            "text": "je navigue vers \"mon profil\""
          },
          {
            "keyword": "Alors",
            "text": "je vois l'écran \"profile\""
          }
        ]
      },
      {
        "name": "Voir mon réseau",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"mon profil\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran contient un texte \"Amis\""
          },
          {
            "keyword": "Et",
            "text": "l'écran contient un texte \"Mes amis\""
          }
        ]
      },
      {
        "name": "Voir un profil de mon réseau",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"mon profil\""
          },
          {
            "keyword": "Quand",
            "text": "je clique sur un participant"
          },
          {
            "keyword": "Alors",
            "text": "je vois l'écran \"user-profile\""
          }
        ]
      },
      {
        "name": "Consulter un événement depuis un profil",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"profil utilisateur\""
          },
          {
            "keyword": "Quand",
            "text": "je clique sur un événement"
          },
          {
            "keyword": "Alors",
            "text": "je vois l'écran \"event-detail\""
          }
        ]
      },
      {
        "name": "Vérifier les données du profil",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"mon profil\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran contient un texte \"Événements\""
          },
          {
            "keyword": "Et",
            "text": "l'écran contient un texte \"Participations\""
          }
        ]
      },
      {
        "name": "Voir les profils publiques",
        "tags": [],
        "steps": []
      }
    ],
    "filePath": "features/user/us-20-profil-reseau.feature",
    "rawContent": "# language: fr\n@USER @priority-1\nFonctionnalité: US-20 Voir le profil des personnes faisant partie de mon réseau\n  En tant qu'utilisateur\n  Je peux voir le profil des personnes faisant partie de mon réseau\n  Ainsi que le profil des personnes publiques\n  Et consulter la description de l'événement afin de savoir si je veux participer\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Accéder à mon profil\n    Étant donné que je suis sur la page \"accueil\"\n    Quand je navigue vers \"mon profil\"\n    Alors je vois l'écran \"profile\"\n\n  Scénario: Voir mon réseau\n    Étant donné que je suis sur la page \"mon profil\"\n    Alors l'écran contient un texte \"Amis\"\n    Et l'écran contient un texte \"Mes amis\"\n\n  Scénario: Voir un profil de mon réseau\n    Étant donné que je suis sur la page \"mon profil\"\n    Quand je clique sur un participant\n    Alors je vois l'écran \"user-profile\"\n\n  Scénario: Consulter un événement depuis un profil\n    Étant donné que je suis sur la page \"profil utilisateur\"\n    Quand je clique sur un événement\n    Alors je vois l'écran \"event-detail\"\n\n  Scénario: Vérifier les données du profil\n    Étant donné que je suis sur la page \"mon profil\"\n    Alors l'écran contient un texte \"Événements\"\n    Et l'écran contient un texte \"Participations\"\n\n  Scénario: Voir les profils publiques\n    * Scénario non implémenté\n",
    "screenIds": [
      "event-detail",
      "home",
      "profile",
      "user-profile"
    ]
  },
  {
    "id": "us-19",
    "name": "US-19 Recevoir un récapitulatif des prochaines rencontres",
    "description": "En tant qu'utilisateur Je peux recevoir un récapitulatif des prochaines rencontres En réceptionnant une liste des événements auxquels je suis inscrit ou qui sont proches de chez moi Afin d'établir un programme des événements auxquels je participe par période",
    "tags": [
      "@NOTIF",
      "@priority-2"
    ],
    "category": "NOTIF",
    "priority": 2,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Voir les événements à venir sur l'accueil",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"accueil\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran contient une section \"Mes événements à venir\""
          }
        ]
      },
      {
        "name": "Voir le récapitulatif par période",
        "tags": [],
        "steps": []
      },
      {
        "name": "Voir les événements proches géographiquement",
        "tags": [],
        "steps": []
      },
      {
        "name": "Voir mes inscriptions",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"mon profil\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran contient une section \"Mes événements à venir\""
          }
        ]
      },
      {
        "name": "Vérifier les données de l'accueil",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"accueil\""
          },
          {
            "keyword": "Alors",
            "text": "les événements affichent leur lieu"
          }
        ]
      }
    ],
    "filePath": "features/notif/us-19-recapitulatif.feature",
    "rawContent": "# language: fr\n# Note: US-19 concerne les récapitulatifs par email - non testable via écrans\n# Les scénarios ci-dessous testent l'affichage sur l'écran d'accueil (aspect UI)\n@NOTIF @priority-2\nFonctionnalité: US-19 Recevoir un récapitulatif des prochaines rencontres\n  En tant qu'utilisateur\n  Je peux recevoir un récapitulatif des prochaines rencontres\n  En réceptionnant une liste des événements auxquels je suis inscrit ou qui sont proches de chez moi\n  Afin d'établir un programme des événements auxquels je participe par période\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Voir les événements à venir sur l'accueil\n    Étant donné que je suis sur la page \"accueil\"\n    Alors l'écran contient une section \"Mes événements à venir\"\n\n  Scénario: Voir le récapitulatif par période\n    * Scénario non implémenté\n\n  Scénario: Voir les événements proches géographiquement\n    * Scénario non implémenté\n\n  Scénario: Voir mes inscriptions\n    Étant donné que je suis sur la page \"mon profil\"\n    Alors l'écran contient une section \"Mes événements à venir\"\n\n  Scénario: Vérifier les données de l'accueil\n    Étant donné que je suis sur la page \"accueil\"\n    Alors les événements affichent leur lieu\n",
    "screenIds": [
      "home",
      "profile"
    ]
  },
  {
    "id": "us-17",
    "name": "US-17 Informer automatiquement d'autres utilisateurs",
    "description": "En tant qu'utilisateur Je peux informer automatiquement d'autres utilisateurs de ma participation à un événement En utilisant un système de notifications pour transmettre le lien de l'événement Afin d'informer les utilisateurs proches, intéressés par la thématique, ou mes abonnés",
    "tags": [
      "@NOTIF",
      "@priority-2"
    ],
    "category": "NOTIF",
    "priority": 2,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Partager un événement auquel je participe",
        "tags": [],
        "steps": []
      },
      {
        "name": "Informer les utilisateurs à proximité",
        "tags": [],
        "steps": []
      },
      {
        "name": "Informer les utilisateurs par thématique",
        "tags": [],
        "steps": []
      },
      {
        "name": "Informer mes abonnés",
        "tags": [],
        "steps": []
      },
      {
        "name": "Combiner les options de notification",
        "tags": [],
        "steps": []
      }
    ],
    "filePath": "features/notif/us-17-informer-utilisateurs.feature",
    "rawContent": "# language: fr\n# Note: US-17 concerne les notifications par email - non testable via écrans\n@NOTIF @priority-2\nFonctionnalité: US-17 Informer automatiquement d'autres utilisateurs\n  En tant qu'utilisateur\n  Je peux informer automatiquement d'autres utilisateurs de ma participation à un événement\n  En utilisant un système de notifications pour transmettre le lien de l'événement\n  Afin d'informer les utilisateurs proches, intéressés par la thématique, ou mes abonnés\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Partager un événement auquel je participe\n    * Scénario non implémenté\n\n  Scénario: Informer les utilisateurs à proximité\n    * Scénario non implémenté\n\n  Scénario: Informer les utilisateurs par thématique\n    * Scénario non implémenté\n\n  Scénario: Informer mes abonnés\n    * Scénario non implémenté\n\n  Scénario: Combiner les options de notification\n    * Scénario non implémenté\n",
    "screenIds": []
  },
  {
    "id": "us-18",
    "name": "US-18 Être informé lorsque de nouveaux participants s'inscrivent",
    "description": "En tant qu'utilisateur Je peux être informé lorsque de nouveaux participants s'inscrivent à un événement auquel je suis inscrit En utilisant un système de notifications Afin de savoir qui participe à un événement",
    "tags": [
      "@NOTIF",
      "@priority-2"
    ],
    "category": "NOTIF",
    "priority": 2,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Configurer les notifications de nouveaux participants",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"paramètres\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran contient une section \"Notifications\""
          }
        ]
      },
      {
        "name": "Activer les notifications pour un événement",
        "tags": [],
        "steps": []
      },
      {
        "name": "Filtrer les notifications par réseau",
        "tags": [],
        "steps": []
      },
      {
        "name": "Voir les nouveaux participants sur l'accueil",
        "tags": [],
        "steps": []
      }
    ],
    "filePath": "features/notif/us-18-nouveaux-participants.feature",
    "rawContent": "# language: fr\n@NOTIF @priority-2\nFonctionnalité: US-18 Être informé lorsque de nouveaux participants s'inscrivent\n  En tant qu'utilisateur\n  Je peux être informé lorsque de nouveaux participants s'inscrivent à un événement auquel je suis inscrit\n  En utilisant un système de notifications\n  Afin de savoir qui participe à un événement\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Configurer les notifications de nouveaux participants\n    Étant donné que je suis sur la page \"paramètres\"\n    Alors l'écran contient une section \"Notifications\"\n\n  Scénario: Activer les notifications pour un événement\n    * Scénario non implémenté\n\n  Scénario: Filtrer les notifications par réseau\n    * Scénario non implémenté\n\n  Scénario: Voir les nouveaux participants sur l'accueil\n    * Scénario non implémenté\n",
    "screenIds": [
      "settings"
    ]
  },
  {
    "id": "us-12",
    "name": "US-12 Consulter la carte/tableau des événements",
    "description": "En tant qu'utilisateur Je peux consulter la carte/tableau des événements auxquels j'ai participé En filtrant les événements par dates ou par personne Afin d'avoir une vue consolidée des événements et lieux de rencontre",
    "tags": [
      "@USER",
      "@priority-2"
    ],
    "category": "USER",
    "priority": 2,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Accéder à la liste des événements depuis le profil",
        "tags": [],
        "steps": []
      },
      {
        "name": "Accéder à la liste des événements depuis découvrir",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"découvrir\""
          },
          {
            "keyword": "Alors",
            "text": "je peux voir la liste des événements"
          }
        ]
      },
      {
        "name": "Filtrer par date",
        "tags": [],
        "steps": []
      },
      {
        "name": "Filtrer par personne",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"profil utilisateur\""
          },
          {
            "keyword": "Alors",
            "text": "je peux voir les événements auxquels l'utilisateur a participé"
          }
        ]
      },
      {
        "name": "Vérifier les données de l'écran événements",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"découvrir\""
          },
          {
            "keyword": "Alors",
            "text": "les événements affichent leur lieu"
          }
        ]
      },
      {
        "name": "Vérifier les données de l'écran profil",
        "tags": [],
        "steps": []
      },
      {
        "name": "Voir la vue carte des événements",
        "tags": [],
        "steps": []
      }
    ],
    "filePath": "features/user/us-12-carte-evenements.feature",
    "rawContent": "# language: fr\n@USER @priority-2\nFonctionnalité: US-12 Consulter la carte/tableau des événements\n  En tant qu'utilisateur\n  Je peux consulter la carte/tableau des événements auxquels j'ai participé\n  En filtrant les événements par dates ou par personne\n  Afin d'avoir une vue consolidée des événements et lieux de rencontre\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Accéder à la liste des événements depuis le profil\n    * Scénario non implémenté\n\n  Scénario: Accéder à la liste des événements depuis découvrir\n    Étant donné que je suis sur la page \"découvrir\"\n    Alors je peux voir la liste des événements\n\n  Scénario: Filtrer par date\n    * Scénario non implémenté\n\n  Scénario: Filtrer par personne\n    Étant donné que je suis sur la page \"profil utilisateur\"\n    Alors je peux voir les événements auxquels l'utilisateur a participé\n\n  Scénario: Vérifier les données de l'écran événements\n    Étant donné que je suis sur la page \"découvrir\"\n    Alors les événements affichent leur lieu\n\n  Scénario: Vérifier les données de l'écran profil\n    * Scénario non implémenté\n\n  Scénario: Voir la vue carte des événements\n    * Scénario non implémenté\n",
    "screenIds": [
      "events",
      "user-profile"
    ]
  },
  {
    "id": "us-25",
    "name": "US-25 Être averti des événements susceptibles de m'intéresser",
    "description": "En tant qu'utilisateur Je peux être notifié lorsqu'un nouvel événement est ajouté près de chez moi Et/ou avec une thématique qui m'intéresse En configurant mes notifications",
    "tags": [
      "@USER",
      "@priority-2"
    ],
    "category": "USER",
    "priority": 2,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Accéder aux paramètres de notification",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"paramètres\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran contient une section \"Notifications\""
          }
        ]
      },
      {
        "name": "Configurer le rayon de notification",
        "tags": [],
        "steps": []
      },
      {
        "name": "Configurer les thématiques d'intérêt",
        "tags": [],
        "steps": []
      }
    ],
    "filePath": "features/user/us-25-notification-evenements.feature",
    "rawContent": "# language: fr\n@USER @priority-2\nFonctionnalité: US-25 Être averti des événements susceptibles de m'intéresser\n  En tant qu'utilisateur\n  Je peux être notifié lorsqu'un nouvel événement est ajouté près de chez moi\n  Et/ou avec une thématique qui m'intéresse\n  En configurant mes notifications\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Accéder aux paramètres de notification\n    Étant donné que je suis sur la page \"paramètres\"\n    Alors l'écran contient une section \"Notifications\"\n\n  Scénario: Configurer le rayon de notification\n    * Scénario non implémenté\n\n  Scénario: Configurer les thématiques d'intérêt\n    * Scénario non implémenté\n",
    "screenIds": [
      "settings"
    ]
  },
  {
    "id": "us-26",
    "name": "US-26 Définir la portée d'un événement",
    "description": "En tant qu'utilisateur Je peux relayer/présenter le contenu d'un événement et le catégoriser par type/thématique En indiquant son rayon d'intérêt en kilomètres Afin de m'assurer que les utilisateurs qui habitent trop loin ne reçoivent pas de notification",
    "tags": [
      "@USER",
      "@priority-2"
    ],
    "category": "USER",
    "priority": 2,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Accéder au formulaire de relai d'événement",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"accueil\""
          },
          {
            "keyword": "Quand",
            "text": "je navigue vers \"relayer un événement\""
          },
          {
            "keyword": "Alors",
            "text": "je vois l'écran \"create-event\""
          }
        ]
      },
      {
        "name": "Définir le rayon d'intérêt",
        "tags": [],
        "steps": []
      },
      {
        "name": "Choisir une thématique",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"relayer un événement\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran contient une section \"Thématique\""
          }
        ]
      },
      {
        "name": "Vérifier les champs obligatoires",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "l'écran \"create-event\" est affiché"
          },
          {
            "keyword": "Alors",
            "text": "le formulaire contient les champs obligatoires suivants:"
          }
        ]
      }
    ],
    "filePath": "features/user/us-26-portee-evenement.feature",
    "rawContent": "# language: fr\n@USER @priority-2\nFonctionnalité: US-26 Définir la portée d'un événement\n  En tant qu'utilisateur\n  Je peux relayer/présenter le contenu d'un événement et le catégoriser par type/thématique\n  En indiquant son rayon d'intérêt en kilomètres\n  Afin de m'assurer que les utilisateurs qui habitent trop loin ne reçoivent pas de notification\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Accéder au formulaire de relai d'événement\n    Étant donné que je suis sur la page \"accueil\"\n    Quand je navigue vers \"relayer un événement\"\n    Alors je vois l'écran \"create-event\"\n\n  Scénario: Définir le rayon d'intérêt\n    * Scénario non implémenté\n\n  Scénario: Choisir une thématique\n    Étant donné que je suis sur la page \"relayer un événement\"\n    Alors l'écran contient une section \"Thématique\"\n\n  Scénario: Vérifier les champs obligatoires\n    Étant donné que l'écran \"create-event\" est affiché\n    Alors le formulaire contient les champs obligatoires suivants:\n      | Nom de l'événement |\n      | Date de début      |\n      | Heure de début     |\n      | Lieu               |\n      | Thématique         |\n",
    "screenIds": [
      "create-event",
      "home"
    ]
  },
  {
    "id": "us-24",
    "name": "US-24 Être notifié des activités de mes contacts",
    "description": "En tant qu'utilisateur Je peux être notifié lorsqu'un contact participe à des événements Afin d'obtenir une synthèse du contenu des ateliers et événements",
    "tags": [
      "@USER",
      "@priority-2"
    ],
    "category": "USER",
    "priority": 2,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Accéder aux paramètres de notification",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"paramètres\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran contient une section \"Notifications\""
          }
        ]
      },
      {
        "name": "Configurer les notifications de contacts",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"paramètres\""
          },
          {
            "keyword": "Alors",
            "text": "je peux configurer mes notifications"
          }
        ]
      },
      {
        "name": "Voir les activités de mes contacts sur l'accueil",
        "tags": [],
        "steps": []
      }
    ],
    "filePath": "features/user/us-24-notification-contacts.feature",
    "rawContent": "# language: fr\n@USER @priority-2\nFonctionnalité: US-24 Être notifié des activités de mes contacts\n  En tant qu'utilisateur\n  Je peux être notifié lorsqu'un contact participe à des événements\n  Afin d'obtenir une synthèse du contenu des ateliers et événements\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Accéder aux paramètres de notification\n    Étant donné que je suis sur la page \"paramètres\"\n    Alors l'écran contient une section \"Notifications\"\n\n  Scénario: Configurer les notifications de contacts\n    Étant donné que je suis sur la page \"paramètres\"\n    Alors je peux configurer mes notifications\n\n  Scénario: Voir les activités de mes contacts sur l'accueil\n    * Scénario non implémenté\n",
    "screenIds": [
      "settings"
    ]
  },
  {
    "id": "us-22",
    "name": "US-22 Parrainer un nouvel utilisateur",
    "description": "En tant qu'utilisateur Je peux parrainer un nouvel utilisateur En lui partageant mon QR code ou lien de contact Afin de savoir combien de personnes ont rejoint le réseau grâce à moi",
    "tags": [
      "@USER",
      "@priority-2"
    ],
    "category": "USER",
    "priority": 2,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Accéder au partage de profil",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"profil\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran contient un bouton \"Partager\""
          }
        ]
      },
      {
        "name": "Naviguer vers le partage de profil",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"profil\""
          },
          {
            "keyword": "Quand",
            "text": "je navigue vers \"partage de profil\""
          },
          {
            "keyword": "Alors",
            "text": "je vois l'écran \"share-profile\""
          }
        ]
      },
      {
        "name": "Voir le QR code de parrainage",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"partage profil\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran contient un texte \"Scannez pour me retrouver sur Festipod\""
          }
        ]
      },
      {
        "name": "Voir le lien de parrainage",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"partage profil\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran contient une section \"Mon lien de profil\""
          },
          {
            "keyword": "Et",
            "text": "l'écran contient un bouton \"Copier\""
          }
        ]
      },
      {
        "name": "Voir les statistiques de parrainage",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"partage profil\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran contient une section \"Statistiques de parrainage\""
          },
          {
            "keyword": "Et",
            "text": "l'écran contient un texte \"Personnes parrainées\""
          },
          {
            "keyword": "Et",
            "text": "l'écran contient un texte \"Scans du QR code\""
          }
        ]
      }
    ],
    "filePath": "features/user/us-22-parrainer.feature",
    "rawContent": "# language: fr\n@USER @priority-2\nFonctionnalité: US-22 Parrainer un nouvel utilisateur\n  En tant qu'utilisateur\n  Je peux parrainer un nouvel utilisateur\n  En lui partageant mon QR code ou lien de contact\n  Afin de savoir combien de personnes ont rejoint le réseau grâce à moi\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Accéder au partage de profil\n    Étant donné que je suis sur la page \"profil\"\n    Alors l'écran contient un bouton \"Partager\"\n\n  Scénario: Naviguer vers le partage de profil\n    Étant donné que je suis sur la page \"profil\"\n    Quand je navigue vers \"partage de profil\"\n    Alors je vois l'écran \"share-profile\"\n\n  Scénario: Voir le QR code de parrainage\n    Étant donné que je suis sur la page \"partage profil\"\n    Alors l'écran contient un texte \"Scannez pour me retrouver sur Festipod\"\n\n  Scénario: Voir le lien de parrainage\n    Étant donné que je suis sur la page \"partage profil\"\n    Alors l'écran contient une section \"Mon lien de profil\"\n    Et l'écran contient un bouton \"Copier\"\n\n  Scénario: Voir les statistiques de parrainage\n    Étant donné que je suis sur la page \"partage profil\"\n    Alors l'écran contient une section \"Statistiques de parrainage\"\n    Et l'écran contient un texte \"Personnes parrainées\"\n    Et l'écran contient un texte \"Scans du QR code\"\n",
    "screenIds": [
      "profile",
      "share-profile"
    ]
  },
  {
    "id": "us-21",
    "name": "US-21 Décider que tous les utilisateurs puissent suivre mes activités",
    "description": "En tant qu'utilisateur Je peux décider que tous les utilisateurs puissent suivre toutes mes activités En déclarant mon profil public Afin de communiquer au sujet de mes déplacements et faire la publicité des événements",
    "tags": [
      "@USER",
      "@priority-2"
    ],
    "category": "USER",
    "priority": 2,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Accéder aux paramètres de profil",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"mon profil\""
          },
          {
            "keyword": "Quand",
            "text": "je navigue vers \"paramètres\""
          },
          {
            "keyword": "Alors",
            "text": "je vois l'écran \"settings\""
          }
        ]
      },
      {
        "name": "Configurer la visibilité du profil",
        "tags": [],
        "steps": [
          {
            "keyword": "Étant donné que ",
            "text": "je suis sur la page \"paramètres\""
          },
          {
            "keyword": "Alors",
            "text": "l'écran contient une section \"Confidentialité\""
          }
        ]
      },
      {
        "name": "Rendre le profil public",
        "tags": [],
        "steps": []
      },
      {
        "name": "Vérifier les données des paramètres",
        "tags": [],
        "steps": []
      },
      {
        "name": "Vérifier les données du profil",
        "tags": [],
        "steps": []
      }
    ],
    "filePath": "features/user/us-21-profil-public.feature",
    "rawContent": "# language: fr\n@USER @priority-2\nFonctionnalité: US-21 Décider que tous les utilisateurs puissent suivre mes activités\n  En tant qu'utilisateur\n  Je peux décider que tous les utilisateurs puissent suivre toutes mes activités\n  En déclarant mon profil public\n  Afin de communiquer au sujet de mes déplacements et faire la publicité des événements\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Accéder aux paramètres de profil\n    Étant donné que je suis sur la page \"mon profil\"\n    Quand je navigue vers \"paramètres\"\n    Alors je vois l'écran \"settings\"\n\n  Scénario: Configurer la visibilité du profil\n    Étant donné que je suis sur la page \"paramètres\"\n    Alors l'écran contient une section \"Confidentialité\"\n\n  Scénario: Rendre le profil public\n    * Scénario non implémenté\n\n  Scénario: Vérifier les données des paramètres\n    * Scénario non implémenté\n\n  Scénario: Vérifier les données du profil\n    * Scénario non implémenté\n",
    "screenIds": [
      "profile",
      "settings"
    ]
  },
  {
    "id": "us-5",
    "name": "US-5 Ajouter/modifier/supprimer un commentaire à un événement",
    "description": "En tant qu'utilisateur Je peux consulter et ajouter/modifier/supprimer un commentaire à un événement En sélectionnant l'icône \"ajouter un commentaire\" en dessous du titre Afin de voir les commentaires précédents et ajouter mes notes personnelles",
    "tags": [
      "@EVENT",
      "@priority-3"
    ],
    "category": "EVENT",
    "priority": 3,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Voir les commentaires existants",
        "tags": [],
        "steps": []
      },
      {
        "name": "Ajouter un commentaire",
        "tags": [],
        "steps": []
      },
      {
        "name": "Modifier un commentaire",
        "tags": [],
        "steps": []
      },
      {
        "name": "Supprimer un commentaire",
        "tags": [],
        "steps": []
      },
      {
        "name": "Enregistrer les interactions avec des individus (Date/Heure/Lieu)",
        "tags": [],
        "steps": []
      }
    ],
    "filePath": "features/event/us-5-commentaires-evenement.feature",
    "rawContent": "# language: fr\n@EVENT @priority-3\nFonctionnalité: US-5 Ajouter/modifier/supprimer un commentaire à un événement\n  En tant qu'utilisateur\n  Je peux consulter et ajouter/modifier/supprimer un commentaire à un événement\n  En sélectionnant l'icône \"ajouter un commentaire\" en dessous du titre\n  Afin de voir les commentaires précédents et ajouter mes notes personnelles\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Voir les commentaires existants\n    * Scénario non implémenté\n\n  Scénario: Ajouter un commentaire\n    * Scénario non implémenté\n\n  Scénario: Modifier un commentaire\n    * Scénario non implémenté\n\n  Scénario: Supprimer un commentaire\n    * Scénario non implémenté\n\n  Scénario: Enregistrer les interactions avec des individus (Date/Heure/Lieu)\n    * Scénario non implémenté\n",
    "screenIds": []
  },
  {
    "id": "us-8",
    "name": "US-8 Consulter et m'inscrire à un macro-événement",
    "description": "En tant qu'utilisateur Je peux consulter et m'inscrire à un événement de type \"Macro-événement\" En créant ou en rattachant des événements existants à ce macro-événement Afin de voir une consolidation des commentaires/liens/ressources/participants",
    "tags": [
      "@EVENT",
      "@priority-3"
    ],
    "category": "EVENT",
    "priority": 3,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Consulter un macro-événement",
        "tags": [],
        "steps": []
      },
      {
        "name": "Voir les événements rattachés",
        "tags": [],
        "steps": []
      },
      {
        "name": "Rattacher un événement existant",
        "tags": [],
        "steps": []
      },
      {
        "name": "Voir la consolidation des participants",
        "tags": [],
        "steps": []
      },
      {
        "name": "Créer un macro-événement",
        "tags": [],
        "steps": []
      },
      {
        "name": "Voir la consolidation des commentaires/liens/ressources",
        "tags": [],
        "steps": []
      },
      {
        "name": "Rattacher à une thématique particulière",
        "tags": [],
        "steps": []
      },
      {
        "name": "Gérer un événement répété sur plusieurs périodes",
        "tags": [],
        "steps": []
      }
    ],
    "filePath": "features/event/us-8-macro-evenement.feature",
    "rawContent": "# language: fr\n@EVENT @priority-3\nFonctionnalité: US-8 Consulter et m'inscrire à un macro-événement\n  En tant qu'utilisateur\n  Je peux consulter et m'inscrire à un événement de type \"Macro-événement\"\n  En créant ou en rattachant des événements existants à ce macro-événement\n  Afin de voir une consolidation des commentaires/liens/ressources/participants\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Consulter un macro-événement\n    * Scénario non implémenté\n\n  Scénario: Voir les événements rattachés\n    * Scénario non implémenté\n\n  Scénario: Rattacher un événement existant\n    * Scénario non implémenté\n\n  Scénario: Voir la consolidation des participants\n    * Scénario non implémenté\n\n  Scénario: Créer un macro-événement\n    * Scénario non implémenté\n\n  Scénario: Voir la consolidation des commentaires/liens/ressources\n    * Scénario non implémenté\n\n  Scénario: Rattacher à une thématique particulière\n    * Scénario non implémenté\n\n  Scénario: Gérer un événement répété sur plusieurs périodes\n    * Scénario non implémenté\n",
    "screenIds": []
  },
  {
    "id": "us-1",
    "name": "US-1 Visualiser un événement terminé (ateliers)",
    "description": "En tant qu'utilisateur Je peux visualiser un événement terminé et consulter le programme détaillé des ateliers par journée/heure Afin de voir les personnes qui ont participé à chaque atelier et consulter les notes/liens/commentaires",
    "tags": [
      "@WORKSHOP",
      "@priority-3"
    ],
    "category": "WORKSHOP",
    "priority": 3,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Accéder aux détails d'un événement terminé",
        "tags": [],
        "steps": []
      },
      {
        "name": "Consulter la liste des participants d'un atelier",
        "tags": [],
        "steps": []
      },
      {
        "name": "Consulter les ressources d'un atelier",
        "tags": [],
        "steps": []
      },
      {
        "name": "Consulter le programme détaillé par journée/heure",
        "tags": [],
        "steps": []
      },
      {
        "name": "Accéder à la zone de partage collective",
        "tags": [],
        "steps": []
      }
    ],
    "filePath": "features/workshop/us-1-visualiser-atelier-termine.feature",
    "rawContent": "# language: fr\n@WORKSHOP @priority-3\nFonctionnalité: US-1 Visualiser un événement terminé (ateliers)\n  En tant qu'utilisateur\n  Je peux visualiser un événement terminé et consulter le programme détaillé des ateliers par journée/heure\n  Afin de voir les personnes qui ont participé à chaque atelier et consulter les notes/liens/commentaires\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Accéder aux détails d'un événement terminé\n    * Scénario non implémenté\n\n  Scénario: Consulter la liste des participants d'un atelier\n    * Scénario non implémenté\n\n  Scénario: Consulter les ressources d'un atelier\n    * Scénario non implémenté\n\n  Scénario: Consulter le programme détaillé par journée/heure\n    * Scénario non implémenté\n\n  Scénario: Accéder à la zone de partage collective\n    * Scénario non implémenté\n",
    "screenIds": []
  },
  {
    "id": "us-2",
    "name": "US-2 Visualiser un événement terminé (notes)",
    "description": "En tant qu'utilisateur Je peux visualiser un événement terminé et consulter le programme détaillé des ateliers Afin d'ajouter d'éventuelles prises de notes/liens ou des commentaires associés à l'atelier",
    "tags": [
      "@WORKSHOP",
      "@priority-3"
    ],
    "category": "WORKSHOP",
    "priority": 3,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Accéder à la zone de notes personnelles",
        "tags": [],
        "steps": []
      },
      {
        "name": "Accéder à la zone de partage publique",
        "tags": [],
        "steps": []
      },
      {
        "name": "Ajouter une note personnelle",
        "tags": [],
        "steps": []
      },
      {
        "name": "Ajouter un lien/ressource",
        "tags": [],
        "steps": []
      },
      {
        "name": "Consulter le programme détaillé des ateliers par journée/heure",
        "tags": [],
        "steps": []
      }
    ],
    "filePath": "features/workshop/us-2-visualiser-notes-atelier.feature",
    "rawContent": "# language: fr\n@WORKSHOP @priority-3\nFonctionnalité: US-2 Visualiser un événement terminé (notes)\n  En tant qu'utilisateur\n  Je peux visualiser un événement terminé et consulter le programme détaillé des ateliers\n  Afin d'ajouter d'éventuelles prises de notes/liens ou des commentaires associés à l'atelier\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Accéder à la zone de notes personnelles\n    * Scénario non implémenté\n\n  Scénario: Accéder à la zone de partage publique\n    * Scénario non implémenté\n\n  Scénario: Ajouter une note personnelle\n    * Scénario non implémenté\n\n  Scénario: Ajouter un lien/ressource\n    * Scénario non implémenté\n\n  Scénario: Consulter le programme détaillé des ateliers par journée/heure\n    * Scénario non implémenté\n",
    "screenIds": []
  },
  {
    "id": "us-14",
    "name": "US-14 Créer/Modifier/Supprimer un atelier",
    "description": "En tant qu'utilisateur Je peux créer/modifier/supprimer un atelier En sélectionnant mon événement et en saisissant les dates et horaires de l'atelier Afin de définir le programme de mon événement et ajouter une description",
    "tags": [
      "@WORKSHOP",
      "@priority-3"
    ],
    "category": "WORKSHOP",
    "priority": 3,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Accéder à la création d'atelier",
        "tags": [],
        "steps": []
      },
      {
        "name": "Vérifier les champs obligatoires pour créer un atelier",
        "tags": [],
        "steps": []
      },
      {
        "name": "Créer un atelier",
        "tags": [],
        "steps": []
      },
      {
        "name": "Modifier un atelier existant",
        "tags": [],
        "steps": []
      },
      {
        "name": "Supprimer un atelier",
        "tags": [],
        "steps": []
      },
      {
        "name": "Sélectionner mon événement parent",
        "tags": [],
        "steps": []
      },
      {
        "name": "Définir les horaires de fin de l'atelier",
        "tags": [],
        "steps": []
      }
    ],
    "filePath": "features/workshop/us-14-creer-atelier.feature",
    "rawContent": "# language: fr\n@WORKSHOP @priority-3\nFonctionnalité: US-14 Créer/Modifier/Supprimer un atelier\n  En tant qu'utilisateur\n  Je peux créer/modifier/supprimer un atelier\n  En sélectionnant mon événement et en saisissant les dates et horaires de l'atelier\n  Afin de définir le programme de mon événement et ajouter une description\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Accéder à la création d'atelier\n    * Scénario non implémenté\n\n  Scénario: Vérifier les champs obligatoires pour créer un atelier\n    * Scénario non implémenté\n\n  Scénario: Créer un atelier\n    * Scénario non implémenté\n\n  Scénario: Modifier un atelier existant\n    * Scénario non implémenté\n\n  Scénario: Supprimer un atelier\n    * Scénario non implémenté\n\n  Scénario: Sélectionner mon événement parent\n    * Scénario non implémenté\n\n  Scénario: Définir les horaires de fin de l'atelier\n    * Scénario non implémenté\n",
    "screenIds": []
  },
  {
    "id": "us-11",
    "name": "US-11 Visualiser le bilan consolidé de l'événement",
    "description": "En tant qu'utilisateur Je peux visualiser le bilan consolidé de l'événement En consultant l'ensemble des commentaires regroupés par atelier Afin d'obtenir une synthèse du contenu de chaque atelier et de l'ensemble des ateliers",
    "tags": [
      "@WORKSHOP",
      "@priority-3"
    ],
    "category": "WORKSHOP",
    "priority": 3,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Accéder au bilan consolidé",
        "tags": [],
        "steps": []
      },
      {
        "name": "Voir les commentaires regroupés par atelier",
        "tags": [],
        "steps": []
      },
      {
        "name": "Voir la synthèse globale",
        "tags": [],
        "steps": []
      }
    ],
    "filePath": "features/workshop/us-11-bilan-consolide.feature",
    "rawContent": "# language: fr\n@WORKSHOP @priority-3\nFonctionnalité: US-11 Visualiser le bilan consolidé de l'événement\n  En tant qu'utilisateur\n  Je peux visualiser le bilan consolidé de l'événement\n  En consultant l'ensemble des commentaires regroupés par atelier\n  Afin d'obtenir une synthèse du contenu de chaque atelier et de l'ensemble des ateliers\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Accéder au bilan consolidé\n    * Scénario non implémenté\n\n  Scénario: Voir les commentaires regroupés par atelier\n    * Scénario non implémenté\n\n  Scénario: Voir la synthèse globale\n    * Scénario non implémenté\n",
    "screenIds": []
  },
  {
    "id": "us-4",
    "name": "US-4 Ajouter/modifier/supprimer un commentaire à un atelier",
    "description": "En tant qu'utilisateur Je peux consulter et ajouter/modifier/supprimer un commentaire à un atelier En sélectionnant l'icône \"ajouter un commentaire\" en dessous du titre de l'atelier Afin de voir les commentaires précédents et ajouter mes commentaires",
    "tags": [
      "@WORKSHOP",
      "@priority-3"
    ],
    "category": "WORKSHOP",
    "priority": 3,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Voir les commentaires existants d'un atelier",
        "tags": [],
        "steps": []
      },
      {
        "name": "Ajouter un commentaire à un atelier",
        "tags": [],
        "steps": []
      },
      {
        "name": "Modifier un commentaire existant",
        "tags": [],
        "steps": []
      },
      {
        "name": "Supprimer un commentaire",
        "tags": [],
        "steps": []
      },
      {
        "name": "Accéder à l'icône ajouter un commentaire",
        "tags": [],
        "steps": []
      }
    ],
    "filePath": "features/workshop/us-4-commentaires-atelier.feature",
    "rawContent": "# language: fr\n@WORKSHOP @priority-3\nFonctionnalité: US-4 Ajouter/modifier/supprimer un commentaire à un atelier\n  En tant qu'utilisateur\n  Je peux consulter et ajouter/modifier/supprimer un commentaire à un atelier\n  En sélectionnant l'icône \"ajouter un commentaire\" en dessous du titre de l'atelier\n  Afin de voir les commentaires précédents et ajouter mes commentaires\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Voir les commentaires existants d'un atelier\n    * Scénario non implémenté\n\n  Scénario: Ajouter un commentaire à un atelier\n    * Scénario non implémenté\n\n  Scénario: Modifier un commentaire existant\n    * Scénario non implémenté\n\n  Scénario: Supprimer un commentaire\n    * Scénario non implémenté\n\n  Scénario: Accéder à l'icône ajouter un commentaire\n    * Scénario non implémenté\n",
    "screenIds": []
  },
  {
    "id": "us-6",
    "name": "US-6 M'inscrire/me désinscrire à un atelier",
    "description": "En tant qu'utilisateur Je peux m'inscrire/me désinscrire à un atelier En regardant si l'événement public existe déjà et en m'enregistrant sur les différents ateliers Afin de m'inscrire à l'atelier tout en visualisant les personnes qui sont déjà pré-inscrites",
    "tags": [
      "@WORKSHOP",
      "@priority-3"
    ],
    "category": "WORKSHOP",
    "priority": 3,
    "background": [
      {
        "keyword": "Étant donné que ",
        "text": "je suis connecté en tant qu'utilisateur"
      }
    ],
    "scenarios": [
      {
        "name": "Voir les ateliers d'un événement",
        "tags": [],
        "steps": []
      },
      {
        "name": "Voir les personnes pré-inscrites à un atelier",
        "tags": [],
        "steps": []
      },
      {
        "name": "S'inscrire à un atelier",
        "tags": [],
        "steps": []
      },
      {
        "name": "Se désinscrire d'un atelier",
        "tags": [],
        "steps": []
      }
    ],
    "filePath": "features/workshop/us-6-inscription-atelier.feature",
    "rawContent": "# language: fr\n@WORKSHOP @priority-3\nFonctionnalité: US-6 M'inscrire/me désinscrire à un atelier\n  En tant qu'utilisateur\n  Je peux m'inscrire/me désinscrire à un atelier\n  En regardant si l'événement public existe déjà et en m'enregistrant sur les différents ateliers\n  Afin de m'inscrire à l'atelier tout en visualisant les personnes qui sont déjà pré-inscrites\n\n  Contexte:\n    Étant donné que je suis connecté en tant qu'utilisateur\n\n  Scénario: Voir les ateliers d'un événement\n    * Scénario non implémenté\n\n  Scénario: Voir les personnes pré-inscrites à un atelier\n    * Scénario non implémenté\n\n  Scénario: S'inscrire à un atelier\n    * Scénario non implémenté\n\n  Scénario: Se désinscrire d'un atelier\n    * Scénario non implémenté\n",
    "screenIds": []
  }
];

export function getFeatureById(id: string): ParsedFeature | undefined {
  return parsedFeatures.find(f => f.id === id);
}

export function getFeaturesByCategory(category: string): ParsedFeature[] {
  return parsedFeatures.filter(f => f.category === category);
}

export function getFeaturesByPriority(priority: number): ParsedFeature[] {
  return parsedFeatures.filter(f => f.priority === priority);
}

export function getAllCategories(): string[] {
  return [...new Set(parsedFeatures.map(f => f.category))];
}

export function getAllPriorities(): number[] {
  return [...new Set(parsedFeatures.map(f => f.priority))].sort((a, b) => a - b);
}
